import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "tipos_vehiculo",
    "tipo_vehiculo",
    "TipoVehiculoForm",
    "/tipos_vehiculo",
);

export default handleActions(reducers, initialState);
